import Register from "../pages/corporate-challenges/register";
import NormalLeaderboard from "../pages/corporate-challenges/participants";
import ChallengeParticipants from "../pages/corporate-challenges/challenge-participants";
import CorporateLeaderboard from "../pages/corporate-challenges/leaderboard";
import CorporateLeaderboardDetail from "../pages/corporate-challenges/leaderboard-detail";
import CombinedLeaderboard from "../pages/corporate-challenges/combined-leaderboard";
import AllLeaderboards from "../pages/corporate-challenges/all-leaderboards";
import DashboardPageLayout from "../layouts/dashboard_layout";
import { ProtectedRoutes } from "./protected_route";

const CorporateChallengesRoutes = {
    path: "/corporate-challenges",
    element: (
        <ProtectedRoutes>
            <DashboardPageLayout />
        </ProtectedRoutes>
    ),
    children: [
        { path: "register", element: <Register /> },
        { path: "participants", element: <NormalLeaderboard /> },
        { path: "leaderboard", element: <CorporateLeaderboard /> },
        { path: "leaderboard/:corporateID", element: <CorporateLeaderboardDetail /> },
        { path: "participants/:corporateID", element: <ChallengeParticipants /> },
        { path: "combined-leaderboard/:corporateID", element: <CombinedLeaderboard /> },
        { path: "all-leaderboards", element: <AllLeaderboards /> },
    ],
};

export default CorporateChallengesRoutes;
